import type { Taste } from "../engine/model";

/** Sour · Balanced · Bitter. Optional; tapping the selected segment clears it. */
const OPTIONS: { value: Taste; label: string }[] = [
  { value: "sour", label: "Sour" },
  { value: "balanced", label: "Balanced" },
  { value: "bitter", label: "Bitter" },
];

export function TasteControl(props: { value: Taste | null; onToggle: (t: Taste) => void }) {
  return (
    <div class="field">
      <span id="taste-label">Taste (optional)</span>
      <div class="segmented" role="radiogroup" aria-labelledby="taste-label">
        {OPTIONS.map((o) => (
          <button key={o.value} type="button" role="radio" aria-checked={props.value === o.value}
                  onClick={() => props.onToggle(o.value)}>{o.label}</button>
        ))}
      </div>
    </div>
  );
}

/** Small glyphs shared by the chart, its legend and the history list. */
export const TASTE_GLYPH: Record<Taste, string> = { sour: "▲", balanced: "●", bitter: "■" };
